import axios from 'axios';
import Config from '../service/config.json';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || Config.APP_BACKEND,
    withCredentials: true, // CAP-4: garante envio/recebimento do cookie httpOnly em toda request.
});

// CAP-4: lock contra N 401 concorrentes — exatamente 1 redirect/mensagem por ciclo de expiração.
let isRedirecting = false;

// Distingue logout explícito (silencioso) de expiração silenciosa (com toast).
let wasExplicitLogout = false;

// Timer client-side de logout proativo — dispara redirect quando o cookie expira localmente,
// evitando que o usuário descubra só ao tentar salvar. Não declara estado sozinho: só faz redirect.
const PROACTIVE_TIMEOUT_MS = 2 * 60 * 60 * 1000; // 2h, mesmo TTL do cookie
let proactiveTimer = null;

function triggerExpirationRedirect(silent = false) {
    if (isRedirecting) return;
    isRedirecting = true;
    if (proactiveTimer) {
        clearTimeout(proactiveTimer);
        proactiveTimer = null;
    }
    localStorage.removeItem('@AppAcademia:user');
    // CAP-6: rota de login é '/' (não existe '/login'). Expiração silenciosa leva ao modal de inatividade.
    const target = silent ? '/' : '/?expired=true';
    window.location.href = target;
}

function armProactiveTimer() {
    if (proactiveTimer) clearTimeout(proactiveTimer);
    proactiveTimer = setTimeout(() => triggerExpirationRedirect(false), PROACTIVE_TIMEOUT_MS);
}

api.interceptors.response.use(
    (response) => {
        // Toda response 2xx significa cookie renovado pelo middleware do servidor — re-arma timer.
        armProactiveTimer();
        return response;
    },
    (error) => {
        const url = error.config?.url || '';
        const isLoginRoute = url.includes('/api/login');
        if (error.response?.status === 401 && !isLoginRoute) {
            triggerExpirationRedirect(wasExplicitLogout);
        }
        return Promise.reject(error);
    }
);

// CAP-4: logout explícito — não exibe toast "Sua sessão expirou".
export async function logout() {
    wasExplicitLogout = true;
    if (proactiveTimer) {
        clearTimeout(proactiveTimer);
        proactiveTimer = null;
    }
    try {
        await api.post('/api/logout');
    } catch (e) {
        // Mesmo se a request falhar, segue com o redirect local.
    }
    localStorage.removeItem('@AppAcademia:user');
    window.location.href = '/';
}

export default api;
